import { useNavigate } from "react-router-dom";
import { intl } from "LocaleWrapper";
import { useStoreState } from "ezStore";

import { PageHeader, Card, Button } from "@cofano/cck";
import { Tabs, Tab, Box } from "@mui/material";

import useTabs from "components/hooks/useTabs";
import Helmet from "components/helmet/Helmet";

import { Language, Fields, hasPluginPermission, hasOptionalFieldPermission, usePermission } from "imports/Utils";

import RelationTable from "view/relations/components/table/RelationTable";

import { RelationType } from "__generated__/enums";

const Relations = () => {

	const navigate = useNavigate();
	const { isReadOnly } = usePermission();
	const session = useStoreState(store => store.session);

	const { selectedTab, selectTab } = useTabs<RelationType>({
		defaultSelected: RelationType.Customer,
	});

	return (
		<div>
			<PageHeader>
				<PageHeader.Title>
					{Language("RELATIONS")}
					<Helmet title={intl.formatMessage({ id: "RELATIONS" })} />
				</PageHeader.Title>

				<PageHeader.Actions>
					{!isReadOnly && (
						<Button onClick={() => navigate("/view/relations/create", { state: { type: selectedTab } })}>
							{intl.formatMessage({ id: "ADD_BUTTON" })}
						</Button>
					)}
				</PageHeader.Actions>
			</PageHeader>

			<Box mb={2}>
				<Card disablePadding>
					<Tabs variant='scrollable' value={selectedTab} onChange={(event, newValue) => selectTab(newValue)}>
						<Tab label={Language("CLIENTS")} value={RelationType.Customer} />

						{hasOptionalFieldPermission(session, Fields.ORDER, "supplier") && (
							<Tab label={Language("SUPPLIERS")} value={RelationType.Supplier} />
						)}

						<Tab label={Language("OPERATORS")} value={RelationType.Operator} />

						<Tab label={Language("SHIP_MANAGER")} value={RelationType.ShipManager} />
						<Tab label={Language("SKIPPER")} value={RelationType.Skipper} />
						<Tab label={Language("CARGO_CONSIGNOR")} value={RelationType.Consignor} />
						<Tab label={Language("APPLICATION_RELATIONS")} value={RelationType.ApplicationRelation} />

						{hasPluginPermission(session, "shippingCompanies") && (
							<Tab label={Language("SHIPPING_COMPANIES")} value={RelationType.ShippingCompany} />
						)}

						{hasPluginPermission(session, "locationRelations") && (
							<Tab label={Language("LOCATION_MANAGERS")} value={RelationType.LocationRelation} />
						)}

						{hasPluginPermission(session, "agents") && (
							<Tab label={Language("AGENTS")} value={RelationType.Agent} />
						)}
						{hasPluginPermission(session, "containerOperators") && (
							<Tab label={Language("CONTAINER_OPERATORS")} value={RelationType.ContainerOperator} />
						)}
						{hasPluginPermission(session, "brokers") && (
							<Tab label={Language("BROKERS")} value={RelationType.Broker} />
						)}
						{hasPluginPermission(session, "surveyors") && (
							<Tab label={Language("SURVEYORS")} value={RelationType.Surveyor} />
						)}
					</Tabs>
				</Card>
			</Box>

			<Card disablePadding>
				<RelationTable key={selectedTab} type={selectedTab} />
			</Card>
		</div>
	);
};

export default Relations;
